/** Shared dropdown / menu item styles — inset rounded hover, not edge-to-edge. */

export const dropdownMenuClasses =
  "bg-surface border border-subtle rounded-control outline-none shadow-md p-1";

export const dropdownItemClasses =
  "block w-full rounded-md px-2 py-1 text-[13px] font-medium text-left text-neutral-700 transition-colors duration-150 ease hover:bg-neutral-100 hover:text-neutral-900";

export const dropdownItemActiveClasses =
  "bg-neutral-100 text-neutral-900";

/** Soft selected state for Listbox options (keeps checkmark readable). */
export const dropdownItemSelectedClasses =
  "bg-blue/10 text-neutral-900";
